import { render, staticRenderFns } from "./PopupAddPriceShiftWindow.vue?vue&type=template&id=78a8b3e8&scoped=true&"
import script from "./PopupAddPriceShiftWindow.vue?vue&type=script&lang=js&"
export * from "./PopupAddPriceShiftWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a8b3e8",
  null
  
)

export default component.exports